import { useState } from 'react';

export default function UpdateToast({ onRefresh }) {
  const [dismissed, setDismissed] = useState(false);

  if (dismissed) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 md:left-auto 
                    md:right-6 md:w-auto bg-primary text-white
                    rounded-xl shadow-lg z-50 p-4 animate-slide-up">
      <div className="flex items-center gap-3">
        <p className="text-sm font-medium flex-1">
          A new version of OrderFlow is available
        </p>
        <button
          onClick={onRefresh}
          className="px-3 py-1.5 bg-accent-dark text-white text-xs font-semibold
                     rounded-lg hover:bg-accent transition-colors whitespace-nowrap"
        >
          Refresh
        </button>
        <button
          onClick={() => setDismissed(true)}
          className="text-gray-400 hover:text-white transition-colors"
          aria-label="Dismiss"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
    </div>
  );
}
